// ─────────────────────────────────────────────────────────────────────────────
// FitSmith — Onderhoud Schemas
// Doel: Fitheid en spiermassa behouden. Onderhoudscalorieën en lagere intensiteit.
// Splits: 2x=[FB-A,FB-B] | 3x=[Upper-A,FB-A,Lower-B] | 4x=[Upper-A,Lower-B,Upper-C,Lower-D]
// ─────────────────────────────────────────────────────────────────────────────

const ex = (code, naam, sets_reps, tempo, rust, notitie) => ({
  code, naam, sets_reps, tempo, rust, superset: null, notitie,
});
const b  = (code, naam, notitie, rust = "90 sec") => ex(code, naam, "3 × 15", "2020", rust, notitie);
const gS = (code, naam, notitie, rust = "90 sec") => ex(code, naam, "3 × 10", "3010", rust, notitie);
const gL = (code, naam, notitie, rust = "60 sec") => ex(code, naam, "3 × 12", "3010", rust, notitie);
const aS = (code, naam, notitie, rust = "120 sec") => ex(code, naam, "4 × 6",  "3110", rust, notitie);
const aL = (code, naam, notitie, rust = "90 sec")  => ex(code, naam, "4 × 12", "3110", rust, notitie);

// ─── FULL BODY A — Quad · Borst · Ham · Rug · Bi · Tri ───────────────────────
const ond_fbA_beg = {
  id: "A", naam: "Sessie A – Full Body",
  exercises: [
    b("A1", "Squat (High Bar)",              "Voeten schouderbreedte. Knieën volgen de richting van de tenen. Onderhoudssessie — focus op techniek.", "90 sec"),
    b("A2", "Dumbbell Bench Press",          "Dumbbells parallel. Duw omhoog en breng ze iets naar elkaar. Borst vooruit. Schouders verankerd.", "90 sec"),
    b("A3", "Romanian Deadlift (Barbell)",   "Heupen naar achteren. Rug vlak. Stang langs de benen. Hamstrings voelen de rek — dit is het doel.", "90 sec"),
    b("A4", "Lat Pulldown (Breed Grip)",     "Licht achteroverleunen. Trek naar de sleutelbeenderen. Ellebogen omlaag. Rug volledig samentrekken.", "90 sec"),
    b("A5", "Hammer Curl",                   "Neutraal grip (duimen omhoog). Bovenarm beweegt niet mee. Volledig strekken onderaan.", "60 sec"),
    b("A6", "Tricep Pushdown (Rechte Stang)","Ellebogen gefixeerd naast het lichaam. Stang omlaag drukken. Triceps volledig samentrekken onderaan.", "60 sec"),
  ],
};
const ond_fbA_gev = {
  id: "A", naam: "Sessie A – Full Body",
  exercises: [
    gS("A1", "Squat (High Bar)",             "3 sec excentrisch. Controleer de techniek. Knieën volgen de tenen. Rug recht bij elke herhaling."),
    gS("A2", "Dumbbell Bench Press",         "3 sec excentrisch. Diepe stretch onderaan. Schouders verankerd. Dumbbells bijna sluiten bovenaan."),
    gS("A3", "Romanian Deadlift (Barbell)",  "3 sec excentrisch. Maximale hamstring stretch. Rug vlak. Stang langs de scheenbenen."),
    gS("A4", "Lat Pulldown (Breed Grip)",    "3 sec excentrisch omhoog. Maximale lat stretch. Trek de ellebogen maximaal omlaag naar de heupen."),
    gL("A5", "Hammer Curl",                  "3 sec excentrisch. Neutraal grip door de beweging. Maximale peak contractie bovenaan.", "60 sec"),
    gL("A6", "Tricep Pushdown (Rechte Stang)","3 sec excentrisch. Ellebogen stabiel. Volledige triceps extensie bij elke herhaling.", "60 sec"),
  ],
};
const ond_fbA_adv = {
  id: "A", naam: "Sessie A – Full Body",
  exercises: [
    aS("A1", "Squat (High Bar)",             "3 sec excentrisch. 1 sec pause onderaan. Explosief omhoog. Techniek prioriteit bij zware belasting."),
    aS("A2", "Dumbbell Bench Press",         "Maximale stretch. 1 sec pause onderaan. 3 sec excentrisch. Explosief omhoog."),
    aS("A3", "Romanian Deadlift (Barbell)",  "Maximale hamstring stretch. 3-1 pause. Rug vlak op elke rep. Heupen maximaal naar achteren."),
    aS("A4", "Lat Pulldown (Breed Grip)",    "Volledige lat stretch. 3 sec excentrisch. Maximale rug samentrekking bij elke herhaling."),
    aL("A5", "Hammer Curl",                  "3 sec excentrisch. Supineer niet. Maximale peak contractie bovenaan. Ellebogen gefixeerd."),
    aL("A6", "Tricep Pushdown (Rechte Stang)","3 sec excentrisch. Maximale extensie. Ellebogen stabiel naast het lichaam. Volledige range."),
  ],
};

// ─── FULL BODY B — Quad · Borst · Ham · Rug · Bi · Tri ───────────────────────
const ond_fbB_beg = {
  id: "B", naam: "Sessie B – Full Body",
  exercises: [
    b("A1", "Leg Press",                      "Voeten schouderbreedte op het platform. Knieën niet volledig strekken. Gecontroleerd zakken.", "90 sec"),
    b("A2", "Incline Dumbbell Press",         "Bank 30–45°. Focus op bovenborst. Dumbbells boven de borst starten. Gecontroleerd neerzakken.", "90 sec"),
    b("A3", "Leg Curl (Liggend)",             "Buikligging. Hiel trekt richting bil. Langzaam terugzakken. Heupen blijven op de bank.", "90 sec"),
    b("A4", "Seated Cable Row (Smal Grip)",   "Zit rechtop. Trek naar de navel. Schouderbladen samentrekken. Rug recht. Geen slingeren.", "90 sec"),
    b("A5", "Dumbbell Curl (Staand)",         "Ellebogen gefixeerd langs het lichaam. Supineer de pols bovenin de beweging voor maximale contractie.", "60 sec"),
    b("A6", "Tricep Pushdown (Touw)",         "Ellebogen naast het lichaam. Trek het touw uiteen onderaan voor maximale triceps samentrekking.", "60 sec"),
  ],
};
const ond_fbB_gev = {
  id: "B", naam: "Sessie B – Full Body",
  exercises: [
    gS("A1", "Leg Press",                     "3 sec excentrisch. Voeten laag voor meer quadriceps. Controleer de excentrische fase. Geen lockout."),
    gS("A2", "Incline Dumbbell Press",        "3 sec excentrisch. Bank 30°. Houd spanning op de bovenborst. Geen volledige sluiting bovenaan."),
    gS("A3", "Leg Curl (Liggend)",            "3 sec excentrisch. Volledige extensie per rep. Heupen verankerd aan de bank. Maximale contractie."),
    gS("A4", "Seated Cable Row (Smal Grip)",  "3 sec excentrisch. Schouderbladen maximaal naar elkaar. Borst licht vooruit bij het trekken."),
    gL("A5", "Dumbbell Curl (Staand)",        "3 sec excentrisch. Supineer bovenaan. Ellebogen gefixeerd. Volledige range per herhaling.", "60 sec"),
    gL("A6", "Tricep Pushdown (Touw)",        "Touw uiteentrekken onderaan. 3 sec excentrisch. Ellebogen stabiel. Focus op de lange kop.", "60 sec"),
  ],
};
const ond_fbB_adv = {
  id: "B", naam: "Sessie B – Full Body",
  exercises: [
    aS("A1", "Leg Press",                     "Maximale kracht. 3 sec excentrisch. Volledige range. Geen lockout bovenaan. Voeten laag."),
    aS("A2", "Incline Dumbbell Press",        "Diepe stretch. 1 sec pause onderaan. Explosief omhoog. 3 sec excentrisch. Bovenborst focus."),
    aS("A3", "Leg Curl (Liggend)",            "Maximale hamstring contractie bovenaan. 3 sec excentrisch. Volledige extensie per rep."),
    aS("A4", "Seated Cable Row (Smal Grip)",  "Maximale rug contractie. 3 sec excentrisch. Schouderbladen volledig samentrekken."),
    aL("A5", "Dumbbell Curl (Staand)",        "3 sec excentrisch. Supineer bovenaan. Maximale peak contractie. Ellebogen gefixeerd."),
    aL("A6", "Tricep Pushdown (Touw)",        "Maximale extensie. Touw uiteentrekken. 3 sec excentrisch. Lange kop focus. Ellebogen stabiel."),
  ],
};

// ─── UPPER A — Borst · Rug · Borst · Rug · Borst · Rug ──────────────────────
const ond_upperA_beg = {
  id: "A", naam: "Sessie A – Upper Body",
  exercises: [
    b("A1", "Dumbbell Bench Press",          "Dumbbells parallel. Diepe stretch. Duw omhoog en breng dumbbells dicht bij elkaar. Schouders verankerd.", "90 sec"),
    b("A2", "Seated Cable Row (Smal Grip)",  "Rechtop zitten. Trek naar de navel. Schouderbladen samentrekken. Rug recht. Geen slingeren.", "90 sec"),
    b("A3", "Incline Dumbbell Press",        "Bank 30–45°. Focus op bovenborst. Dumbbells starten naast de borst. Gecontroleerd neerzakken.", "90 sec"),
    b("A4", "Lat Pulldown (Breed Grip)",     "Licht achteroverleunen. Trek naar sleutelbeenderen. Ellebogen omlaag. Rug samentrekken.", "90 sec"),
    b("A5", "Machine Chest Press",           "Stoel afstellen op borsthoogte. Duw naar voren. Gecontroleerd terug. Borst vooruit tijdens de beweging.", "60 sec"),
    b("A6", "Dumbbell Row (Eenhandig)",      "Knie op de bank. Trek langs het lichaam omhoog. Elleboog gaat hoog. Romp stabiel en rug recht.", "60 sec"),
  ],
};
const ond_upperA_gev = {
  id: "A", naam: "Sessie A – Upper Body",
  exercises: [
    gS("A1", "Dumbbell Bench Press",         "3 sec excentrisch. Maximale stretch onderaan. Schouders verankerd. Geen volledige sluiting bovenaan."),
    gS("A2", "Seated Cable Row (Smal Grip)", "3 sec excentrisch. Schouderbladen maximaal naar elkaar. Borst licht vooruit bij het trekken."),
    gS("A3", "Incline Dumbbell Press",       "3 sec excentrisch. Bank 30°. Focus bovenborst. Geen volledige sluiting — houd spanning."),
    gS("A4", "Lat Pulldown (Breed Grip)",    "3 sec excentrisch omhoog. Maximale lat stretch. Trek ellebogen maximaal omlaag."),
    gL("A5", "Machine Chest Press",          "3 sec excentrisch. Explosief naar voren. Volledige range of motion. Borst maximaal samentrekken.", "60 sec"),
    gL("A6", "Dumbbell Row (Eenhandig)",     "3 sec excentrisch laten zakken. Elleboog zo hoog mogelijk. Maximale rug contractie.", "60 sec"),
  ],
};
const ond_upperA_adv = {
  id: "A", naam: "Sessie A – Upper Body",
  exercises: [
    aS("A1", "Dumbbell Bench Press",         "Maximale stretch. 1 sec pause onderaan. 3 sec excentrisch. Explosief omhoog."),
    aS("A2", "Seated Cable Row (Smal Grip)", "Maximale rug contractie. 3 sec excentrisch. Schouderbladen volledig samentrekken."),
    aS("A3", "Incline Dumbbell Press",       "Diepe stretch. 1 sec pause. 3 sec excentrisch. Bovenborst focus. Explosief omhoog."),
    aS("A4", "Lat Pulldown (Breed Grip)",    "Volledige lat stretch. 3 sec excentrisch. Maximale rug samentrekking."),
    aL("A5", "Machine Chest Press",          "1 sec pause vooraan. 3 sec excentrisch. Maximale borst contractie. Explosieve kracht."),
    aL("A6", "Dumbbell Row (Eenhandig)",     "Maximale rug samentrekking. 3 sec excentrisch. Elleboog zo hoog mogelijk bij elke rep."),
  ],
};

// ─── UPPER C — Borst · Rug · Borst · Rug · Borst · Rug ──────────────────────
const ond_upperC_beg = {
  id: "C", naam: "Sessie C – Upper Body",
  exercises: [
    b("A1", "Bench Press",                   "Schouderbladen samenknijpen en in de bank drukken. Stang daalt naar onderkant borst. Voeten plat.", "90 sec"),
    b("A2", "Barbell Row – Overhand",        "Romp 45° voorover. Trek de stang naar de buik. Ellebogen hoog. Knieën licht gebogen. Rug vlak.", "90 sec"),
    b("A3", "Machine Chest Press",           "Stoel afstellen op borsthoogte. Duw naar voren. Gecontroleerd terug. Borst vooruit.", "90 sec"),
    b("A4", "Lat Pulldown (Reverse Grip)",   "Onderhands grip. Trek naar de borst. Licht achteroverleunen. Meer biceps betrokken.", "90 sec"),
    b("A5", "Pec Deck (Machine Fly)",        "Ellebogen op de pads. Borst vooruit. Armen samenknijpen en langzaam terug. Focus op de borst stretch.", "60 sec"),
    b("A6", "Rear Delt Fly (Dumbbell)",      "Voorovergebogen. Armen breed opzijwaarts opheffen. Lichte gewichten. Langzame beweging.", "60 sec"),
  ],
};
const ond_upperC_gev = {
  id: "C", naam: "Sessie C – Upper Body",
  exercises: [
    gS("A1", "Bench Press",                  "3 sec excentrisch. Stang raakt de borst bij elke rep. Schouderbladen verankerd. Explosief omhoog."),
    gS("A2", "Barbell Row – Overhand",       "3 sec excentrisch laten zakken. Trek naar de buik. Ellebogen hoog. Rug vlak op elke herhaling."),
    gS("A3", "Machine Chest Press",          "3 sec excentrisch. Explosief naar voren. Volledige range. Borst volledig samentrekken bovenaan."),
    gS("A4", "Lat Pulldown (Reverse Grip)",  "3 sec excentrisch. Trek naar sleutelbeenderen. Licht achteroverleunen. Focus op de rug."),
    gL("A5", "Pec Deck (Machine Fly)",       "Maximale borst stretch. 3 sec excentrisch. Knijp de borst samen bij sluiting. Isolatiefocus.", "60 sec"),
    gL("A6", "Rear Delt Fly (Dumbbell)",     "Licht gewicht. Breed optillen. 3 sec excentrisch. Focus op achterschouder. Vermijd slingeren.", "60 sec"),
  ],
};
const ond_upperC_adv = {
  id: "C", naam: "Sessie C – Upper Body",
  exercises: [
    aS("A1", "Bench Press",                  "1 sec pause onderaan. Explosief omhoog. 3 sec excentrisch. Maximale borstspanning."),
    aS("A2", "Barbell Row – Overhand",       "Explosief trekken. 3 sec excentrisch laten zakken. Maximale rug samentrekking. Ellebogen hoog."),
    aS("A3", "Machine Chest Press",          "1 sec pause vooraan. 3 sec excentrisch. Maximale borst contractie. Explosieve kracht."),
    aS("A4", "Lat Pulldown (Reverse Grip)",  "Volledige range. 3 sec excentrisch. Maximale lat stretch. Trek explosief."),
    aL("A5", "Pec Deck (Machine Fly)",       "Maximale stretch. 3 sec excentrisch. Borst volledig samentrekken. Lichte elleboogbuiging."),
    aL("A6", "Rear Delt Fly (Dumbbell)",     "Gecontroleerde beweging. 3 sec excentrisch. Achterschouder volledig samentrekken. Licht gewicht."),
  ],
};

// ─── LOWER B — Quad · Ham · Quad · Ham · Kuit · Core ─────────────────────────
const ond_lowerB_beg = {
  id: "B", naam: "Sessie B – Lower Body",
  exercises: [
    b("A1", "Squat (High Bar)",              "Voeten schouderbreedte. Knieën volgen de tenen. Onderhoud — focus op de techniek en consistentie.", "90 sec"),
    b("A2", "Romanian Deadlift (Barbell)",   "Heupen naar achteren. Rug vlak. Stang langs de benen. Hamstrings voelen de rek.", "90 sec"),
    b("A3", "Leg Press",                     "Voeten schouderbreedte. Knieën niet volledig strekken. Gecontroleerd zakken. Geen lockout.", "90 sec"),
    b("A4", "Leg Curl (Liggend)",            "Hiel naar bil. Langzaam terugzakken. Heupen op de bank. Volledige extensie per herhaling.", "90 sec"),
    b("A5", "Standing Calf Raise (Machine)", "Volledig strekken bovenaan. Volledig zakken onderaan. Langzame, gecontroleerde beweging.", "60 sec"),
    b("A6", "Crunch",                        "Handen naast het hoofd. Schouders van de grond. Buikspieren samentrekken. Langzaam terug.", "60 sec"),
  ],
};
const ond_lowerB_gev = {
  id: "B", naam: "Sessie B – Lower Body",
  exercises: [
    gS("A1", "Squat (High Bar)",             "3 sec excentrisch. Explosief omhoog. Knieën volgen de tenen. Rug recht bij elke herhaling."),
    gS("A2", "Romanian Deadlift (Barbell)",  "3 sec excentrisch. Heupen maximaal naar achteren. Stang langs scheenbenen. Hamstring stretch."),
    gS("A3", "Leg Press",                    "3 sec excentrisch. Voeten laag voor meer quadriceps. Geen lockout bovenaan."),
    gS("A4", "Leg Curl (Liggend)",           "3 sec excentrisch. Maximale hiel-bil afstand. Heupen verankerd aan de bank."),
    gL("A5", "Standing Calf Raise (Machine)","3 sec excentrisch. 1 sec bovenaan. Volledige range. Focus op gastrocnemius contractie.", "60 sec"),
    gL("A6", "Crunch",                       "3 sec excentrisch. Maximale buik contractie bovenaan. Handen naast het hoofd, niet trekken.", "60 sec"),
  ],
};
const ond_lowerB_adv = {
  id: "B", naam: "Sessie B – Lower Body",
  exercises: [
    aS("A1", "Squat (High Bar)",             "3 sec excentrisch. 1 sec pause onderaan. Explosief omhoog. Kracht behouden bij onderhoud."),
    aS("A2", "Romanian Deadlift (Barbell)",  "Maximale hamstring stretch. 3-1 pause. Rug vlak. Stang langs de benen bij elke rep."),
    aS("A3", "Leg Press",                    "3 sec excentrisch. Voeten laag. Volledige range. Geen lockout. Maximale kracht."),
    aS("A4", "Leg Curl (Liggend)",           "Maximale hamstring samentrekking. 3 sec excentrisch. 1 sec pause bovenaan."),
    aL("A5", "Standing Calf Raise (Machine)","Volledig zakken. 2 sec squeeze bovenaan. 3 sec excentrisch. Maximale Achilles stretch."),
    aL("A6", "Crunch",                       "3 sec excentrisch. Gewicht op de borst voor weerstand. Maximale buik contractie per rep."),
  ],
};

// ─── LOWER D — Quad · Ham · Quad · Ham · Kuit · Core ─────────────────────────
const ond_lowerD_beg = {
  id: "D", naam: "Sessie D – Lower Body",
  exercises: [
    b("A1", "Bulgarian Split Squat",         "Achterste voet op de bank. Zak recht omlaag. Voorste knie volgt de teen. Romp rechtop.", "90 sec"),
    b("A2", "Romanian Deadlift (Dumbbell)",  "Dumbbells langs de benen naar beneden. Heupen naar achteren. Rug recht. Hamstrings rekken.", "90 sec"),
    b("A3", "Hack Squat (Machine)",          "Voeten laag voor meer quadriceps focus. Controleer de excentrische fase. Geen lockout.", "90 sec"),
    b("A4", "Leg Curl (Zittend)",            "Rug in de stoel. Hiel trekt omlaag. Volledig strekken voor het begin van elke herhaling.", "90 sec"),
    b("A5", "Seated Calf Raise (Machine)",   "Gewicht op de bovenkant van de knieën. Volledig strekken en zakken. Gecontroleerde beweging.", "60 sec"),
    b("A6", "Crunch",                        "Handen naast het hoofd. Schouders van de grond. Buikspieren samentrekken. Langzaam terug.", "60 sec"),
  ],
};
const ond_lowerD_gev = {
  id: "D", naam: "Sessie D – Lower Body",
  exercises: [
    gS("A1", "Bulgarian Split Squat",        "3 sec excentrisch. Knie raakt bijna de grond. Romp rechtop. Per been zo diep mogelijk."),
    gS("A2", "Romanian Deadlift (Dumbbell)", "3 sec excentrisch. Dumbbells langs de benen. Maximale hamstring stretch."),
    gS("A3", "Hack Squat (Machine)",         "3 sec excentrisch. Voeten laag. Volledige range of motion. Geen lockout bovenaan."),
    gS("A4", "Leg Curl (Zittend)",           "3 sec excentrisch. Volledig strekken per rep. Hiel maximaal naar het zadel trekken."),
    gL("A5", "Seated Calf Raise (Machine)",  "3 sec excentrisch. Maximale Achilles stretch onderaan. 1 sec squeeze bovenaan.", "60 sec"),
    gL("A6", "Crunch",                       "3 sec excentrisch. Buikspieren maximaal rekken. Schouders volledig van de grond per herhaling.", "60 sec"),
  ],
};
const ond_lowerD_adv = {
  id: "D", naam: "Sessie D – Lower Body",
  exercises: [
    aS("A1", "Bulgarian Split Squat",        "Maximale diepte. 3 sec excentrisch. 1 sec pause onderaan. Explosief omhoog. Per been."),
    aS("A2", "Romanian Deadlift (Dumbbell)", "Maximale hamstring stretch. 3-1 pause bij knie. Rug vlak. Dumbbells dicht langs de benen."),
    aS("A3", "Hack Squat (Machine)",         "Maximale kracht behoud. 3 sec excentrisch. 1 sec pause onderaan. Voeten laag."),
    aS("A4", "Leg Curl (Zittend)",           "Maximale samentrekking. 3 sec excentrisch. 1 sec pause bovenaan. Soleus actief."),
    aL("A5", "Seated Calf Raise (Machine)",  "3 sec excentrisch. Volledig zakken. 2 sec squeeze bovenaan. Soleus en gastrocnemius focus."),
    aL("A6", "Crunch",                       "Extra weerstand op de borst. 3 sec excentrisch. Maximale buik contractie. Volledige range."),
  ],
};

// ─── EXPORT ───────────────────────────────────────────────────────────────────
export const ONDERHOUD_SCHEMAS = {
  "onderhoud-beginner-2x": {
    meta: {
      doel: "Onderhoud", sub_doel: "fitheid en spiermassa behouden",
      niveau: "Beginner", frequentie: "2x per week",
      schema_naam: "Onderhoud Beginner – 2x per week",
      weekstructuur: "Maandag: Sessie A – Full Body  |  Donderdag: Sessie B – Full Body",
      notitie: "Twee onderhoudssessies per week. Ideaal voor drukke periodes. Focus op consistentie en techniek met lagere intensiteit.",
    },
    sessions: [ond_fbA_beg, ond_fbB_beg],
  },
  "onderhoud-beginner-3x": {
    meta: {
      doel: "Onderhoud", sub_doel: "fitheid en spiermassa behouden",
      niveau: "Beginner", frequentie: "3x per week",
      schema_naam: "Onderhoud Beginner – 3x per week",
      weekstructuur: "Maandag: Sessie A – Upper Body  |  Woensdag: Sessie B – Full Body  |  Vrijdag: Sessie C – Lower Body",
      notitie: "Upper-Full-Lower split voor onderhoud. Alle spiergroepen effectief gestimuleerd met voldoende herstel.",
    },
    sessions: [ond_upperA_beg, ond_fbA_beg, ond_lowerB_beg],
  },
  "onderhoud-beginner-4x": {
    meta: {
      doel: "Onderhoud", sub_doel: "fitheid en spiermassa behouden",
      niveau: "Beginner", frequentie: "4x per week",
      schema_naam: "Onderhoud Beginner – 4x per week",
      weekstructuur: "Maandag: Sessie A – Upper  |  Dinsdag: Sessie B – Lower  |  Donderdag: Sessie C – Upper  |  Vrijdag: Sessie D – Lower",
      notitie: "Upper-Lower split twee keer per week voor onderhoud. Hogere frequentie met behoud van lagere intensiteit.",
    },
    sessions: [ond_upperA_beg, ond_lowerB_beg, ond_upperC_beg, ond_lowerD_beg],
  },
  "onderhoud-gevorderd-2x": {
    meta: {
      doel: "Onderhoud", sub_doel: "fitheid en spiermassa behouden",
      niveau: "Gevorderd", frequentie: "2x per week",
      schema_naam: "Onderhoud Gevorderd – 2x per week",
      weekstructuur: "Maandag: Sessie A – Full Body  |  Donderdag: Sessie B – Full Body",
      notitie: "Twee gevorderde onderhoudssessies per week. Excentrische controle staat centraal voor het behoud van spiermassa.",
    },
    sessions: [ond_fbA_gev, ond_fbB_gev],
  },
  "onderhoud-gevorderd-3x": {
    meta: {
      doel: "Onderhoud", sub_doel: "fitheid en spiermassa behouden",
      niveau: "Gevorderd", frequentie: "3x per week",
      schema_naam: "Onderhoud Gevorderd – 3x per week",
      weekstructuur: "Maandag: Sessie A – Upper Body  |  Woensdag: Sessie B – Full Body  |  Vrijdag: Sessie C – Lower Body",
      notitie: "Upper-Full-Lower split met gevorderd onderhoudsprofiel. Hogere excentrische focus en excentrische controle.",
    },
    sessions: [ond_upperA_gev, ond_fbA_gev, ond_lowerB_gev],
  },
  "onderhoud-gevorderd-4x": {
    meta: {
      doel: "Onderhoud", sub_doel: "fitheid en spiermassa behouden",
      niveau: "Gevorderd", frequentie: "4x per week",
      schema_naam: "Onderhoud Gevorderd – 4x per week",
      weekstructuur: "Maandag: Sessie A – Upper  |  Dinsdag: Sessie B – Lower  |  Donderdag: Sessie C – Upper  |  Vrijdag: Sessie D – Lower",
      notitie: "Upper-Lower split voor gevorderd onderhoud. Consistentie en krachtstabilisatie zijn de focus.",
    },
    sessions: [ond_upperA_gev, ond_lowerB_gev, ond_upperC_gev, ond_lowerD_gev],
  },
  "onderhoud-advanced-2x": {
    meta: {
      doel: "Onderhoud", sub_doel: "fitheid en spiermassa behouden",
      niveau: "Advanced", frequentie: "2x per week",
      schema_naam: "Onderhoud Advanced – 2x per week",
      weekstructuur: "Maandag: Sessie A – Full Body  |  Donderdag: Sessie B – Full Body",
      notitie: "Advanced onderhoud — hoge intensiteit per sessie bij lage frequentie. 4×6 preserveert maximale krachtstatus.",
    },
    sessions: [ond_fbA_adv, ond_fbB_adv],
  },
  "onderhoud-advanced-3x": {
    meta: {
      doel: "Onderhoud", sub_doel: "fitheid en spiermassa behouden",
      niveau: "Advanced", frequentie: "3x per week",
      schema_naam: "Onderhoud Advanced – 3x per week",
      weekstructuur: "Maandag: Sessie A – Upper Body  |  Woensdag: Sessie B – Full Body  |  Vrijdag: Sessie C – Lower Body",
      notitie: "Upper-Full-Lower advanced onderhoud. Volledige kracht en spiermassa behouden met optimale stimulatie.",
    },
    sessions: [ond_upperA_adv, ond_fbA_adv, ond_lowerB_adv],
  },
  "onderhoud-advanced-4x": {
    meta: {
      doel: "Onderhoud", sub_doel: "fitheid en spiermassa behouden",
      niveau: "Advanced", frequentie: "4x per week",
      schema_naam: "Onderhoud Advanced – 4x per week",
      weekstructuur: "Maandag: Sessie A – Upper  |  Dinsdag: Sessie B – Lower  |  Donderdag: Sessie C – Upper  |  Vrijdag: Sessie D – Lower",
      notitie: "Advanced Upper-Lower onderhoud. Maximaal kracht en spiermassa behoud bij optimale trainingsfrequentie.",
    },
    sessions: [ond_upperA_adv, ond_lowerB_adv, ond_upperC_adv, ond_lowerD_adv],
  },
};
